@switch (severity()) {
  @case ('real-money') {
    <div data-testid="environment-banner" class="w-full bg-red-600 text-white text-center text-sm font-semibold py-2 px-4">
      {{ environment() | uppercase }} — this environment moves real funds. Deposits and withdrawals here are real.
    </div>
  }
  @case ('test') {
    <div data-testid="environment-banner" class="w-full bg-surface-variant text-on-surface-variant text-center text-xs font-medium py-1.5 px-4">
      {{ environment() | uppercase }} — test environment, no real funds
    </div>
  }
}
